import Cookies from "js-cookie";
import { VerifyJWT } from "core-web/libs/GrebbCommerceAPI/Products";
import getQueryParams from "core-web/utils/getQueryParams";

const getGoogleDiscountData = async (variants, partNo, location, url, applicationId, ssrCookies = {}) => {
    const googleDiscountHash = getQueryParams(location)?.pv2;
    const partNoWithCookie =
        variants.find((variant) => {
            const cookieName = `googleDiscount-${variant.part_no}`;
            return ssrCookies?.[cookieName] ?? Cookies.get(cookieName);
        })?.part_no || partNo;
    const cookie =
        ssrCookies?.[`googleDiscount-${partNoWithCookie}`] ?? Cookies.get(`googleDiscount-${partNoWithCookie}`);

    if (!!googleDiscountHash) {
        try {
            const googleDiscountData = await VerifyJWT(googleDiscountHash, "google", url, applicationId);
            const { p: priceIncVat, exp: expiration, o: objectId } = googleDiscountData || {};
            const discountTimeStamp = expiration;
            const discountExpirationDate = new Date(discountTimeStamp * 1000);

            return {
                discountPriceIncVat: priceIncVat,
                productPartNo: objectId,
                discountExpirationDate,
                discountTimeStamp,
            };
        } catch (e) {
            return null;
        }
    } else if (cookie) {
        return typeof cookie === "string" ? JSON.parse(cookie) : cookie;
    }

    return null;
};

export default getGoogleDiscountData;
